/** Must match 2025Backend/utils/serviceFeeUtils.js */
export const SERVICE_BOOKING_FEE_RATE = 0.0162;

export function computeServiceFeeAmount(subTotal, couponDiscount, isReschedule, rescheduleFee) {
  const coupon = Number(couponDiscount) || 0;
  let postDiscount = 0;
  if (isReschedule) {
    postDiscount = Math.max(0, (Number(rescheduleFee) || 0) - coupon);
  } else {
    postDiscount = Math.max(0, (Number(subTotal) || 0) - coupon);
  }
  return Math.round(postDiscount * SERVICE_BOOKING_FEE_RATE * 100) / 100;
}
